import React from 'react';

type DetailFieldProps = {
  label: string;
  variant?: 'caption' | 'heading';
  children: React.ReactNode;
};

const labelClassName: Record<
  NonNullable<DetailFieldProps['variant']>,
  string
> = {
  caption: 'mb-1 text-xs uppercase text-blueGrayDark',
  heading: 'mb-1 font-semibold',
};

const DetailField: React.FC<DetailFieldProps> = ({
  label,
  variant = 'caption',
  children,
}) => (
  <div>
    <div className={labelClassName[variant]}>{label}</div>
    <div>{children}</div>
  </div>
);

export default DetailField;
